import { __awaiter, __extends, __generator } from "tslib";
import { BaseTelemetryPlugin } from '@microsoft/1ds-core-js';
function isWindows11() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var getHighEntropyValues;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(navigator.userAgent && navigator.userAgent.indexOf('Windows') > 0)) return [3 /*break*/, 2];
                    getHighEntropyValues = (_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.getHighEntropyValues;
                    if (!getHighEntropyValues) return [3 /*break*/, 2];
                    return [4 /*yield*/, navigator.userAgentData.getHighEntropyValues(['platformVersion'])
                            .then(function (ua) {
                            var majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0], 10);
                            if (majorPlatformVersion >= 13) {
                                return true;
                            }
                            return false;
                        })
                            .catch(function (_e) {
                            return false;
                        })];
                case 1: return [2 /*return*/, _b.sent()];
                case 2: return [2 /*return*/, false];
            }
        });
    });
}
/**
 * A plugin that overrides the ext.os.name field with "Windows 11"
 * on appropriate devices. The Collector automatically populates the field,
 * which gets renamed to DeviceInfo.OsName in Aria. However, the Windows 11
 * detection is not generally available server-side, so we have to overwrite the
 * field here.
 */
// Usage:
// Windows 11 detection is asynchronous, so
// the telemetry logger must be enabled with enableQueue: true,
// and the OneDSSink with OsPlugin must be attached once detection is complete.
// Once the sink is attached, telemetry will start to flow to the sink.
//
// async function attachSinkToLogger(telemetryLogger: ISimpleTelemetryLogger) {
//   const osPlugin = new OsPlugin();
//   await osPlugin.detectWindows11();
//
//   let oneDSSinkProperties: OneDSSinkProperties = {
//     endpointUrl: OneDSEndpoint.PUBLIC,
//     plugins: [osPlugin]
//   };
//   const oneDSSink = new OneDSSink(persistentDataFields, oneDSSinkProperties);
//   // The sink gets added to the logger, and the queue automatically gets flushed
//   telemetryLogger.addSink(oneDSSink);
// }
//
// const telemetryLogger = new TelemetryLogger(undefined, undefined, {
//   // Enable queue, otherwise events will get dropped until the sink is attached
//   enableQueue: true
// });
// telemetryLogger.setTenantToken(TenantTokens.tenantName, TenantTokens.ariaTenantToken, TenantTokens.nexusTenantToken);
// // At this point, you can start sending events to the telemetry logger.
//
// // Trigger the function to asynchronously create a 1DS sink and attach it to the logger,
// // after which time telemetry will start flowing
// attachSinkToLogger(telemetryLogger);
//
var OsPlugin = /** @class */ (function (_super) {
    __extends(OsPlugin, _super);
    function OsPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The identifier for this plugin
         */
        _this.identifier = 'Windows11';
        /**
         * The priority for this plugin.
         * Plugins with lesser priority numbers are processed earlier.
         * Other commonly used plugins have these priorities:
         *   Properties     3
         *   WebAnalytics 180
         *   PartAPlugin  450
         *   PrivacyGuard 499
         *   PostChannel 1011
         * We want OsPlugin to happen before PartAPlugin.
         */
        _this.priority = 449;
        _this._isWindows11 = false;
        return _this;
    }
    /**
     * Process the event and add os fields if necessary.
     * @param telemetryEvent - The event to be processed.
     * @param itemCtx - This is the context for the current request, ITelemetryPlugin instances
     * can optionally use this to access the current core instance or define / pass additional information
     * to later plugins (vs appending items to the telemetry item)
     */
    OsPlugin.prototype.processTelemetry = function (telemetryEvent, itemCtx) {
        if (this._isWindows11) {
            telemetryEvent.ext = telemetryEvent.ext || {};
            telemetryEvent.ext.os = telemetryEvent.ext.os || {};
            telemetryEvent.ext.os.name = 'Windows 11';
        }
        var itemContext = this._getTelCtx(itemCtx);
        this.processNext(telemetryEvent, itemContext);
    };
    /**
     * Runs operating system detection logic
     * @returns - A promise that resolves once detection is complete
     */
    OsPlugin.prototype.detectOs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, isWindows11()];
                    case 1:
                        _a._isWindows11 = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return OsPlugin;
}(BaseTelemetryPlugin));
export { OsPlugin };
//# sourceMappingURL=OsPlugin.js.map